// Configure Turbo to use custom confirm dialogs
// Replaces: app/assets/javascripts/turbo_confirm_setup.js (which used Bootbox/jQuery)

import { logger } from "./logger"

// Initialize initialization tracker if it doesn't exist
if (!window.__turboInitTracker) {
  window.__turboInitTracker = {
    components: {},
    checkComplete: function() {
      const allComplete = Object.values(this.components).every(status => status === true)
      if (allComplete && !this.logged) {
        this.logged = true
        // Always show in production (special init message)
        logger.init('✓ Turbo initialization complete')
      }
    },
    markComplete: function(component) {
      this.components[component] = true
      this.checkComplete()
    },
    markError: function(component, error) {
      this.components[component] = false
      // Only show errors in development
      logger.error(`✗ ${component} initialization failed:`, error)
      this.checkComplete()
    }
  }
}

// Wait for Turbo to be available
const configureTurboConfirm = () => {
  if (typeof window.Turbo === 'undefined' || !window.Turbo.config || !window.Turbo.config.forms) {
    setTimeout(configureTurboConfirm, 100)
    return
  }

  try {
    // Configure Turbo to use SweetAlert2 styled confirm dialogs
    window.Turbo.config.forms.confirm = function(message, element) {
      return window.Swal.fire({
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check"></i> אישור',
        cancelButtonText: '<i class="fa fa-times"></i> ביטול',
        customClass: {
          confirmButton: 'btn btn-danger me-2',
          cancelButton: 'btn btn-secondary ms-2',
          actions: 'd-flex gap-2 justify-content-center'
        },
        buttonsStyling: false,
        reverseButtons: true  // Show cancel on right (RTL layout)
      }).then((result) => result.isConfirmed)
    }

    // Handle confirmations for links with data-turbo-confirm
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[data-turbo-confirm]')
      if (!link) return

      const form = link.closest('form[data-turbo="false"]')
      if (form) {
        // Link inside turbo=false form - handle manually
        e.preventDefault()
        e.stopPropagation()

        window.Swal.fire({
          text: link.dataset.turboConfirm,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '<i class="fa fa-check"></i> אישור',
          cancelButtonText: '<i class="fa fa-times"></i> ביטול',
          customClass: {
            confirmButton: 'btn btn-danger me-2',
            cancelButton: 'btn btn-secondary ms-2',
            actions: 'd-flex gap-2 justify-content-center'
          },
          buttonsStyling: false,
          reverseButtons: true  // Show cancel on right (RTL layout)
        }).then((result) => {
          if (result.isConfirmed && link.dataset.turboMethod) {
            // Clear Turbo cache to prevent stale page state after navigation
            Turbo.cache.clear()
            // Create form to submit with method
            const submitForm = document.createElement('form')
            submitForm.method = 'post'
            submitForm.action = link.href

            const csrfToken = document.querySelector('meta[name="csrf-token"]')
            if (csrfToken) {
              const csrfInput = document.createElement('input')
              csrfInput.type = 'hidden'
              csrfInput.name = 'authenticity_token'
              csrfInput.value = csrfToken.content
              submitForm.appendChild(csrfInput)
            }

            const methodInput = document.createElement('input')
            methodInput.type = 'hidden'
            methodInput.name = '_method'
            methodInput.value = link.dataset.turboMethod
            submitForm.appendChild(methodInput)

            document.body.appendChild(submitForm)
            submitForm.submit()
          } else if (result.isConfirmed) {
            // Clear Turbo cache to prevent stale page state after navigation
            Turbo.cache.clear()
            window.location.href = link.href
          }
        })
      }
    }, true)

    window.__turboInitTracker.markComplete('Turbo confirm handler')
  } catch (error) {
    window.__turboInitTracker.markError('Turbo confirm handler', error)
  }
}

// Start configuration when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', configureTurboConfirm)
} else {
  configureTurboConfirm()
}
